<template>
  <div class="d-flex flex-column">
    <div class="title">{{this.year}}</div>
    <div style="background-color: #707070; height: 0px; width: 40%"></div>
  </div>
</template>

<script>
export default {
  name: "MainWorksSectionHeader",
  props:{
    year:{
      type: String,
      default: "YEAR"
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.title{
  font-family: Helvetica;
  font-weight: bold;
  font-size: 2rem;
  line-height: 1.15;

  color: white;
  text-shadow: 2px 2px 5px #1b1e21;

  @include media-breakpoint-up(md) {
    font-size: 2.5rem;
  }
}

</style>